jQuery(document).ready(function($) {
    // Ensure jQuery runs after DOM is ready
    var path = window.location.pathname;

    // Clean up the path: replace slashes with dashes and remove leading/trailing slashes
    var pageClass = path.replace(/\/+/g, '-').replace(/^-|-$/g, '').toLowerCase();

    // Add specific classes for certain pages
    if (path.includes('/pages/about')) {
        $('body').addClass('inner-abouts');
    } else if (path.includes('/pages/contact')) {
        $('body').addClass('inner-contact');
    } else {
        // Add a generic class for other pages
        if (pageClass === '') {
            pageClass = 'home'; // Handle homepage
        }
        $('body').addClass('page-' + pageClass);
    }
});